import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "./i18n/index.js";
import { Layout } from "./routes/Layout.js";
import { Hub } from "./pages/Hub.js";
import { StaticPage } from "./pages/StaticPage.js";
import { NotFound } from "./pages/NotFound.js";
import { GamePlaceholder } from "./games/GamePlaceholder.js";
import { Timeslip } from "./games/timeslip/Timeslip.js";
import { Crowflight } from "./games/crowflight/Crowflight.js";
import { Huesswork } from "./games/huesswork/Huesswork.js";
import { AdminApp } from "./admin/AdminApp.js";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Admin is German-only with its own chrome, outside the public
            DE/EN layout (spec §11). */}
        <Route path="/admin/*" element={<AdminApp />} />
        <Route
          path="/*"
          element={
            <I18nProvider>
              <Routes>
                <Route element={<Layout />}>
                  <Route path="/" element={<Hub />} />
                  <Route path="/imprint" element={<StaticPage slug="imprint" />} />
                  <Route path="/privacy" element={<StaticPage slug="privacy" />} />
                  <Route path="/credits" element={<StaticPage slug="credits" />} />
                  <Route path="/spiele/timeslip" element={<Timeslip />} />
                  <Route path="/spiele/crowflight" element={<Crowflight />} />
                  <Route path="/spiele/huesswork" element={<Huesswork />} />
                  <Route path="/spiele/:gameId" element={<GamePlaceholder />} />
                  <Route path="*" element={<NotFound />} />
                </Route>
              </Routes>
            </I18nProvider>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
